import React from 'react';
import { FormattedNumber } from 'react-intl';
import { Table, Dropdown, Popup } from 'semantic-ui-react';
import { utcMoment, dateTimeFormatted } from '../../utilities/dateUtils';
import { formatProductCell } from '../../utilities/productUtil';
import { PRODUCT_FAMILY_SA } from '../../constants/productFamily';
import {
  ROW_ACTION_FORCE_GUARANTEE,
  FORCE_GUARANTEE_ACTION_LABEL,
  FORCE_GUARANTEE_UNSUPPORTED_PRODUCT,
  FORCE_GUARANTEE_UNKNOWN_PRODUCT,
} from '../../constants/forceGuarantee';
import './ListRow.css';

const formatDate = date => (date ? dateTimeFormatted(utcMoment(date)) : '');

const IneligiblePurchasesListRow = (
  actionHandler,
  selectedProduct,
  canForceGuarantee
) => ineligiblePurchase => {
  const {
    externalId,
    vin,
    make,
    model,
    modelYear,
    odometer,
    salePrice,
    auctionCode,
    auctionName,
    saleNumber,
    saleLane,
    saleRun,
    purchaseDate,
    ineligibilityCode,
    ineligibilityReason,
    ineligibilityNotice,
    productCategory,
    productName,
    sellerNo,
    buyerNo,
  } = ineligiblePurchase;

  // The list mixes products under "All Products", so the side comes from the row itself first.
  const rowProduct = productCategory || selectedProduct;
  const dealerNumber = rowProduct === PRODUCT_FAMILY_SA ? sellerNo : buyerNo;

  // Hidden without the permission, disabled with an explanation for a non-seller or undetermined product.
  const rowMenuOptions = [];
  if (canForceGuarantee) {
    const isSellerSide = rowProduct === PRODUCT_FAMILY_SA;
    rowMenuOptions.push({
      key: ROW_ACTION_FORCE_GUARANTEE,
      text: FORCE_GUARANTEE_ACTION_LABEL,
      value: ROW_ACTION_FORCE_GUARANTEE,
      disabled: !isSellerSide,
      description: isSellerSide
        ? undefined
        : (productCategory
          ? FORCE_GUARANTEE_UNSUPPORTED_PRODUCT
          : FORCE_GUARANTEE_UNKNOWN_PRODUCT),
      'data-testid': 'row-action-force-guarantee',
    });
  }

  const vehicle = [modelYear, make, model].filter(Boolean).join(' ');

  const currencyProps = price => ({
    currency: 'USD',
    style: 'currency',
    minimumFractionDigits: 0,
    value: price,
  });

  const auctionInfo = [
    auctionName || auctionCode,
    saleNumber,
    saleLane,
    saleRun,
  ]
    .filter(part => part !== null && part !== undefined && part !== '')
    .join(' / ');

  const failureReason = (
    <span className='ineligible-failure-reason'>
      {ineligibilityReason || ineligibilityCode}
    </span>
  );

  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, ineligiblePurchase);
  };

  return (
    <Table.Row key={externalId} data-testid='purchase-row'>
      <Table.Cell>{vin}</Table.Cell>
      <Table.Cell>{formatDate(purchaseDate)}</Table.Cell>
      <Table.Cell>{dealerNumber}</Table.Cell>
      <Table.Cell>{auctionInfo}</Table.Cell>
      <Table.Cell>{vehicle}</Table.Cell>
      <Table.Cell>
        {odometer != null && <FormattedNumber value={odometer} />}
      </Table.Cell>
      <Table.Cell>
        {salePrice != null
          && React.createElement(FormattedNumber, currencyProps(salePrice))}
      </Table.Cell>
      <Table.Cell data-testid='failure-reason-cell'>
        {ineligibilityNotice ? (
          <Popup
            trigger={failureReason}
            content={ineligibilityNotice}
            position='top right'
          />
        ) : (
          failureReason
        )}
      </Table.Cell>
      <Table.Cell data-testid='product-cell'>
        {formatProductCell(productName)}
      </Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          value={null}
          disabled={rowMenuOptions.length === 0}
          data-testid='row-actions'
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default IneligiblePurchasesListRow;
